export const ErrorType = Object.freeze({
    CC_ID_NOT_FOUND: "CC_ID_NOT_FOUND",
    CC_NOT_FOUND: "CC_NOT_FOUND",
    USR_ID_NOT_FOUND: "USR_ID_NOT_FOUND",
    USR_NOT_FOUND: "USR_NOT_FOUND",
    USR_NO_VC_CREDITS: "USR_NO_VC_CREDITS",
    USR_NO_MSG_CREDITS: "USR_NO_MSG_CREDITS",
    USR_NO_VCC_CREDITS: 'USR_NO_VCC_CREDITS',
    USR_NOT_SUBSCRIBED:"USR_NOT_SUBSCRIBED",
    VC_IN_PROGRESS: "VC_IN_PROGRESS",
    VC_SIGNED_URL_REQ_FAILED: "VC_SIGNED_URL_REQ_FAILED",
    VC_CID_NOT_FOUND: "VC_CID_NOT_FOUND",
    VC_CONNECT_UPDATE_ID_FAILED: "VC_CONNECT_UPDATE_ID_FAILED",
    VC_END_FAILED: "VC_END_FAILED",
    // Video Call Errors
    VDC_IN_PROGRESS: 'VDC_IN_PROGRESS',
    VDC_END_FAILED: 'VDC_END_FAILED',
    
});
